/**
 *
 * @module endpoint
 *
 */

import Services from './services/entry';

/**
 *
 * @class Endpoint
 * @extends {SDK.Services.ServiceEndpoint}
 *
 */
export default class Endpoint extends Services.ServiceEndpoint {}



// WEBPACK FOOTER //
// ./src/endpoint.js